import { render } from "./FullReportDev.vue?vue&type=template&id=060f8e40"
import script from "./FullReportDev.vue?vue&type=script&lang=js"
export * from "./FullReportDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__